
        var normalize = require("../../../node_modules/san-loader/lib/runtime/normalize.js");
        require('/Users/duanhong/Source/Lean/LeanPM/webapps/shared/src/components/ConnectAdmin/ConnectAdmin.san?lang=less&san=&type=style&index=0');
var injectStyles = [];

        var template = require('./ConnectAdmin.html');
        
        var script = require('./ConnectAdmin.ts').default;
        module.exports = require('./ConnectAdmin.ts');
    
        module.exports.default = normalize(script, template, injectStyles);
        /* san-hmr component */
    